if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.productSection = this.closest('[id^="MainProduct-"]') || this.closest('.shopify-section');
      this.colourRoot = this.productSection?.querySelector('[data-z-multi-colour]');
      if (this.colourRoot) {
        this.colourVariants = JSON.parse(this.colourRoot.querySelector('[data-z-colour-variants]').textContent);
        this.colourIndex = Number(this.colourRoot.dataset.colourIndex);
        this.colourRoot.addEventListener('click', event => {
          const colourBox = event.target.closest('label')?.querySelector('[data-z-colour]');
          if (colourBox) {
            window.clearTimeout(this.colourPreviewTimer);
            this.colourPreviewTimer = window.setTimeout(() => {
              const variant = this.colourVariants.find(v => v.options[this.colourIndex] === colourBox.value && v.featured_media);
              const gallery = this.productSection.querySelector('media-gallery');
              if (!gallery) return;
              if (variant) gallery.setActiveMedia(gallery.id.replace('MediaGallery-', '') + '-' + variant.featured_media.id, true, true);
              else gallery.scrollIntoView({behavior: 'smooth', block: 'start'});
            }, 0);
          }
          const button = event.target.closest('[data-z-colour-step]');
          if (!button) return;
          const input = button.closest('[data-z-colour-row]').querySelector('[data-z-colour-quantity]');
          input.value = String(Math.max(1, (Number(input.value) || 1) + Number(button.dataset.zColourStep)));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
        this.colourRoot.addEventListener('change', event => {
          if (!event.target.matches('[data-z-colour]')) return;
          const current = this.colourVariants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
          const checked = [...this.colourRoot.querySelectorAll('[data-z-colour]:checked')];
          const previewColour = event.target.checked ? event.target.value : checked[0]?.value;
          if (current && checked.length && ((event.target.checked && event.target.value !== current.options[this.colourIndex]) || !checked.some(box => box.value === current.options[this.colourIndex]))) {
            const picker = this.productSection.querySelector('variant-radios, variant-selects');
            const fields = picker?.querySelectorAll('fieldset');
            const radio = fields?.[this.colourIndex] ? [...fields[this.colourIndex].querySelectorAll('input[type="radio"]')].find(input => input.value === previewColour) : null;
            const select = picker?.querySelectorAll('select')[this.colourIndex];
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', {bubbles: true}));
            } else if (select) {
              select.value = previewColour;
              select.dispatchEvent(new Event('change', {bubbles: true}));
            }
          }
          this.refreshColours();
        });
        this.productSection.addEventListener('change', () => setTimeout(() => this.refreshColours(), 100));
        this.refreshColours();
      }
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    refreshColours() {
      const current = this.colourVariants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
      if (!current) return;
      const boxes = [...this.colourRoot.querySelectorAll('[data-z-colour]')];
      if (!this.colourReady) {
        boxes.forEach(box => { box.checked = box.value === current.options[this.colourIndex]; });
        this.colourReady = true;
      }
      boxes.forEach(box => {
        const match = this.colourVariants.find(v => v.options.every((value, i) => value === (i === this.colourIndex ? box.value : current.options[i])));
        const available = Boolean(match?.available);
        if (!available) box.checked = false;
        box.dataset.available = String(available);
        box.closest('label').querySelector('[data-z-colour-status]').textContent = available ? '' : this.colourRoot.dataset.unavailable;
      });
      if (!boxes.some(box => box.checked)) {
        const fallback = boxes.find(box => box.value === current.options[this.colourIndex] && box.dataset.available === 'true');
        if (fallback) fallback.checked = true;
      }
      const count = boxes.filter(box => box.checked).length;
      boxes.forEach(box => {
        box.disabled = box.dataset.available !== 'true' || (box.checked && count === 1);
        const row = box.closest('[data-z-colour-row]');
        row.querySelector('[data-z-colour-quantity-wrap]').hidden = !box.checked;
        row.querySelector('[data-z-colour-quantity]').disabled = !box.checked;
      });
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      let colourItems = null;
      let singleColourQuantity = null;
      const colourQuantities = new Map();
      if (this.colourRoot) {
        this.refreshColours();
        const current = this.colourVariants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
        const choices = [...this.colourRoot.querySelectorAll('[data-z-colour]:checked')];
        for (const box of choices) {
          const input = box.closest('[data-z-colour-row]').querySelector('[data-z-colour-quantity]');
          if (!input.checkValidity() || !Number.isInteger(input.valueAsNumber) || input.valueAsNumber < 1) {
            this.handleErrorMessage(this.colourRoot.dataset.quantityError);
            input.reportValidity();
            input.focus();
            return;
          }
          colourQuantities.set(box.value, input.valueAsNumber);
        }
        if (choices.length === 1) singleColourQuantity = colourQuantities.get(choices[0].value);
        if (current && choices.length > 1) {
          colourItems = choices.map(box => this.colourVariants.find(v => v.available && v.options.every((value, i) => value === (i === this.colourIndex ? box.value : current.options[i]))));
          if (colourItems.some(v => !v)) {
            this.handleErrorMessage(this.colourRoot.dataset.error);
            return;
          }
        }
      }

      const deliverySelection = this.productSection?.querySelector('[data-zandomart-delivery]');
      let postalDelivery = false;
      if (deliverySelection) {
        try {
          const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
          if (!cartResponse.ok) throw new Error('cart');
          const currentCart = await cartResponse.json();
          const merchandise = currentCart.items.filter(item => !window.zandomartPostalFee?.isFee(item));
          postalDelivery = merchandise.length > 0 && merchandise.every(item => item.properties?._zandomart_delivery_mode === 'postal');
        } catch (err) {
          this.handleErrorMessage(window.cartStrings.error);
          return;
        }
      }
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Collect appointment selections at the exact moment the Shopify AJAX cart is built.
      // Resolve from the product section, including when the custom Liquid is outside the form.
      const productSection = this.closest('[id^="MainProduct-"]') || this.closest('.shopify-section') || document;
      const tryOnRoot = productSection.querySelector('[data-zandomart-two-sizes]');
      const deliveryRoot = productSection.querySelector('[data-zandomart-delivery]');
      const formData = new FormData(this.form);
      const paymentChoice = productSection.querySelector('input[name="part_payments"]:checked');
      const fullPayment = paymentChoice?.value === 'full';
      const depositInputs = [...this.form.querySelectorAll('[data-attribute-hidden="depo"]'), ...productSection.querySelectorAll('[data-attribute-hidden="depo"]')];
      const depositFields = new Map();
      for (const input of depositInputs) {
        if (!input.name || input.disabled || !input.value || depositFields.has(input.name)) continue;
        if (/^properties\[.+\]$/.test(input.name) || input.name === 'selling_plan') depositFields.set(input.name, input.value);
      }
      if (!postalDelivery && !fullPayment) {
        for (const [name, value] of depositFields) formData.set(name, value);
      } else {
        for (const input of depositInputs) if (input.name) formData.delete(input.name);
      }
      if (singleColourQuantity !== null) formData.set('quantity', String(singleColourQuantity));
      if (tryOnRoot && !postalDelivery) {
        const sizes = Array.from(tryOnRoot.querySelectorAll('[data-zandomart-size]:checked')).map(el => el.value);
        if (sizes.length) formData.set('properties[Tailles à essayer]', sizes.join(' + '));
      }
      if (deliveryRoot) {
        const city = deliveryRoot.querySelector('[data-zandomart-zone]');
        const date = deliveryRoot.querySelector('[data-zandomart-date]');
        const slot = deliveryRoot.querySelector('[data-zandomart-slot]:checked');
        if (city && city.value && city.value !== 'local' && city.value !== 'canada-post') formData.set('properties[Zone de livraison]', city.options[city.selectedIndex].text);
        if (date && date.value) formData.set('properties[Date de livraison]', date.value);
        if (slot && slot.value) formData.set('properties[Créneau de livraison]', slot.value);
      }
      // Store appointment details as cart attributes as well: deposit apps can replace
      // the product line and discard its line item properties.
      if (postalDelivery) {
        formData.delete('properties[Tailles à essayer]');
        formData.delete('properties[Créneau de livraison]');
        formData.delete('properties[Date de livraison]');
        formData.delete('selling_plan');
        this.form.querySelectorAll('[data-attribute-hidden="depo"]').forEach(input => formData.delete(input.name));
        formData.set('properties[_zandomart_delivery_mode]', 'postal');
        formData.set('properties[' + deliveryRoot.dataset.postalPaymentLabel + ']', deliveryRoot.dataset.postalFull);
        for (const key of [...formData.keys()]) {
          if (key.startsWith('properties[') && /_part_payment|_pp_|_flow|_deposit_charge|_cart_flow/.test(key)) formData.delete(key);
        }
      }
      const appointment = {
        'Zandomart - Mode de livraison': postalDelivery ? 'Postes Canada / Canada Post' : 'Zandomart',
        'Zandomart - Paiement': postalDelivery ? deliveryRoot.dataset.postalFull : ''
      };
      const trySizes = String(formData.get('properties[Tailles à essayer]') || '').trim();
      if (trySizes && !postalDelivery) {
        const variantIds = colourItems ? colourItems.map(variant=>variant.id) : [formData.get('id')];
        variantIds.filter(Boolean).forEach(id=>{appointment['Zandomart - Tailles - '+id]=trySizes;});
      }
      const paymentProperties = {};
      for (const [name, value] of depositFields) {
        if (name.startsWith('properties[') && !postalDelivery && !fullPayment) paymentProperties[name.slice(11, -1)] = value;
      }
      const depositValue = String(paymentProperties._part_payment_amount || '').trim();
      formData.set('properties[_zandomart_payment_intent]', postalDelivery || fullPayment || !depositValue ? 'full' : 'deposit');
      if (paymentChoice || depositValue) {
        const paymentVariantIds = colourItems ? colourItems.map(variant=>variant.id) : [formData.get('id')];
        paymentVariantIds.filter(Boolean).forEach(id=>{
          appointment['Zandomart - Dépôt - '+id] = postalDelivery || fullPayment ? '' : depositValue;
          appointment['Zandomart - Paiement - '+id] = postalDelivery || fullPayment ? '' : encodeURIComponent(JSON.stringify(paymentProperties));
        });
      }
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && value) {
          const name = key.slice(11, -1);
          if (['Zone de livraison'].includes(name)) {
            appointment['Zandomart - ' + name] = String(value);
          }
        }
      }
      if (Object.keys(appointment).length) {
        try {
          await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: appointment})
          });
        } catch (err) {
          console.warn('Zandomart appointment cart attributes could not be saved', err);
        }
      }
      const applyOffer = (id, quantity, properties) => window.zandomartPaymentPolicy?.forVariant(id,quantity,properties,postalDelivery) || properties;
      const baseProperties = {};
      for (const [key,value] of formData.entries()) {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match) baseProperties[match[1]] = value;
      }
      const offerProperties = applyOffer(formData.get('id'),Number(formData.get('quantity') || 1),baseProperties);
      for (const key of [...formData.keys()]) if (key.startsWith('properties[')) formData.delete(key);
      for (const [key,value] of Object.entries(offerProperties)) formData.set('properties['+key+']',value);
      formData.delete('selling_plan');
      const deliveryForVariant = id => deliveryRoot?.deliveryVariants?.find(variant => String(variant.id) === String(id))?.lead || 6;
      formData.set('properties[_zandomart_lead_days]', String(deliveryForVariant(formData.get('id'))));
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (colourItems) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match) properties[match[1]] = value;
        }
        const quantity = Number(formData.get('quantity') || 1);
        const sellingPlan = formData.get('selling_plan');
        const payload = {items: colourItems.map(variant => ({id: variant.id, quantity: colourQuantities.get(variant.options[this.colourIndex]) || quantity, properties: {...applyOffer(variant.id,colourQuantities.get(variant.options[this.colourIndex]) || quantity,properties), _zandomart_lead_days: String(deliveryForVariant(variant.id))}, ...(sellingPlan ? {selling_plan: sellingPlan} : {})}))};
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
        }
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);
      } else {
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          if (window.zandomartPostalFee) {
            const sections = this.cart ? this.cart.getSectionsToRender().map(section => section.id) : [];
            const feeResult = await window.zandomartPostalFee.sync(null, sections);
            if (feeResult.changed && feeResult.cart.sections) response.sections = feeResult.cart.sections;
          }
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (colourItems) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.handleErrorMessage(e.message || window.cartStrings.error);
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}



